import {
  getUserDetailsStore,
  pages,
  setUserDetailsStore,
  setUserDetailsStoreOne,
} from ".";
import { api, apiRoutes } from "../../api";
import { IUserDetails } from "./types";

export const fetchUserDetailsPosts = async () => {
  try {
		const {currentPage, page, username, offset} = getUserDetailsStore()
    if (page == 0) {
			setUserDetailsStore({ isPostsLoading: true });
		}
		console.log('api');
    const { data } = await api.get(pages[currentPage].apiRoute(username), {
      params: { currentPage: page, offset },
    });
    setUserDetailsStoreOne('posts', (v) => [...v, ...data.posts])
		setUserDetailsStore({isFetching: false, totalPages: data.totalPages})
  } catch (err) {
  } finally {
    setUserDetailsStore({ isPostsLoading: false });
  }
};

export const fetchGetUserDetails = async () => {
  try {
    setUserDetailsStore({ isUserInfoLoading: true });
    const { data } = await api.get<{ user: IUserDetails }>(
      apiRoutes.getUserDetails(getUserDetailsStore().username)
    );
    setUserDetailsStore({ user: data.user });
  } catch (err) {
  } finally {
    setUserDetailsStore({ isUserInfoLoading: false });
  }
};

export const fetchSubscribe = async () => {
  try {
    setUserDetailsStore({ isSubscribeButtonLoading: true });
    const { data } = await api.patch(
      apiRoutes.patchSubscribe(getUserDetailsStore().user._id)
    );
    setUserDetailsStoreOne("user", (v) => ({
      ...v,
      isSubscribed: data.isSubscribed,
      subsCount: data.subsCount,
    }));
  } catch (err) {
  } finally {
    setUserDetailsStore({ isSubscribeButtonLoading: false });
  }
};

export const fetchDescEdit = async () => {
  try {
    setUserDetailsStore({ isDescEditFormLoading: true });
    const { status, data } = await api.patch(apiRoutes.patchUser(), {
      description: getUserDetailsStore().descInput,
    });
    if (status == 200) {
      setUserDetailsStoreOne("user", (v) => ({
        ...v,
        description: data.user.description,
      }));
			setUserDetailsStore({
        isDescriptionEditing: false,
      });
    }
  } catch (err) {
  } finally {
    setUserDetailsStore({ isDescEditFormLoading: false });
  }
};
